import { render } from "./TariffsUnique.vue?vue&type=template&id=188f3a87&scoped=true&ts=true"
import script from "./TariffsUnique.vue?vue&type=script&lang=ts"
export * from "./TariffsUnique.vue?vue&type=script&lang=ts"

import "./TariffsUnique.vue?vue&type=style&index=0&id=188f3a87&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188f3a87"]])

export default __exports__